import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetOfficesCountByStateParams } from '../types/IGetOfficesCountByStateParams';
import { IOfficesCountByStateResponse } from '../types/IOfficesCountByStateResponse';

export const GetOfficesCountByStateClient = {
  getOfficesCountByState: async ({
    state,
  }: IGetOfficesCountByStateParams): Promise<IOfficesCountByStateResponse> => {
    const headers = await getAuthHeaders();

    const response = await tempMeeApi.get(
      `/offer-service/offices/states/${encodeURIComponent(state)}/counts`,
      { headers },
    );

    return response.data;
  },
};
